import React from 'react'
import './Info.css'
import Footer from '../UIElements/Footer'
import HomeHomeNavigation from './HomeHomeNavigation'

// PDFs
import PBHL_BYLAWS from './../../../../src/PBHL_BYLAWS_2025_2.pdf'
import PBHL_RULES from './../../../../src/2026 PBHL Rules and Regulations.pdf'

import Dec24 from './../../../../src/meetingMinutes/12-6-2024.pdf'
import Dec24_2 from './../../../../src/meetingMinutes/12-23-2024.pdf'
import Feb25 from './../../../../src/meetingMinutes/2-19-2025.PDF'
import Mar25 from './../../../../src/meetingMinutes/3-10-2025.pdf'

import Nov25 from './../../../../src/meetingMinutes/11-13-2025.pdf'
import Dec25 from './../../../../src/meetingMinutes/12-8-2025.pdf'
import Jan26 from './../../../../src/meetingMinutes/1-14-2026.pdf'
import Feb26 from './../../../../src/meetingMinutes/2-18-2026.pdf'
import Apr26 from './../../../../src/meetingMinutes/4-13-2026.pdf'
import July26 from './../../../../src/meetingMinutes/7-6-2026.pdf'
import Aug26 from './../../../../src/meetingMinutes/8-19-2026.pdf'

import FalconsReview2025 from './../../../../src/meetingMinutes/FalconsReview2025.pdf'
import SouthPittsburghReview2025 from './../../../../src/meetingMinutes/SouthPittsburghReview2025.pdf'
import MurrysvilleReview2025 from './../../../../src/meetingMinutes/MurrysvilleReview2025.pdf'
import CranberryReview2025 from './../../../../src/meetingMinutes/CranberryReview2025.pdf'

const InfoRow = ({ href, title, subtitle }) => {
	return (
		<a className='infoRow' href={href} target='_blank' rel='noreferrer'>
			<div className='infoRowLeft'>
				<div className='infoIcon' aria-hidden='true'>
					{/* Simple doc icon (replace with your nicer icons if you want) */}
					<svg viewBox='0 0 24 24' width='22' height='22'>
						<path
							fill='currentColor'
							d='M6 2h8l4 4v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1.5V7h3.5L14 3.5zM7 11h10v2H7v-2zm0 4h10v2H7v-2z'
						/>
					</svg>
				</div>

				<div className='infoRowText'>
					<div className='infoRowTitle'>{title}</div>
					{subtitle ? <div className='infoRowSubtitle'>{subtitle}</div> : null}
				</div>
			</div>

			<div className='infoChevron' aria-hidden='true'>
				<svg viewBox='0 0 24 24' width='22' height='22'>
					<path fill='currentColor' d='M9 6l6 6-6 6' />
				</svg>
			</div>
		</a>
	)
}

const InfoSection = ({ label, children }) => {
	return (
		<div className='infoSection'>
			<div className='infoSectionHeader'>
				<div className='infoSectionLabel'>{label}</div>
				<div className='infoSectionRule' />
			</div>
			<div className='infoCard'>{children}</div>
		</div>
	)
}

const Info = () => {
	const rulesURL =
		'https://usaballhockey.com/wp-content/uploads/2024/11/USA-Ball-Hockey-Official-Rule-Book-Revised-07.06.2021.pdf'

	const officialDocs = [
		{
			//href: PBHL_BYLAWS,
			title: 'BY-LAWS',
			//subtitle: 'Official league by-laws',
			subtitle: '(COMING SOON!!)',
		},
		{
			//href: PBHL_RULES,
			title: '2026 PABHA Rules & Regulations',
			//subtitle: 'PABHA rules and regulations',
			subtitle: '(COMING SOON!!)',
		},
		{
			href: rulesURL,
			title: 'USA Ball Hockey Official Rule Book',
			subtitle: 'Governing body rules',
		},
	]

	const meetingMinutesByYear = {
		2026: [
			{
				href: Aug26,
				title: 'August Meeting Minutes (EOY)',
				subtitle: 'August 2026',
			},
			{
				href: July26,
				title: 'July Meeting Minutes',
				subtitle: 'July 2026',
			},
			{
				href: Apr26,
				title: 'April Meeting Minutes',
				subtitle: 'April 2026',
			},
			{
				href: Feb26,
				title: 'February Meeting Minutes',
				subtitle: 'February 2026',
			},
			{
				href: Jan26,
				title: 'January Meeting Minutes',
				subtitle: 'January 2026',
			},
		],
		/* 2025: [
			{
				href: Dec25,
				title: 'December Meeting Minutes',
				subtitle: 'December 2025',
			},
			{
				href: Nov25,
				title: 'November Meeting Minutes',
				subtitle: 'November 2025',
			},
			{
				href: CranberryReview2025,
				title: 'Cranberry Classic Review',
				subtitle: '2025',
			},
			{
				href: MurrysvilleReview2025,
				title: 'Murrysville Review',
				subtitle: '2025',
			},
			{
				href: FalconsReview2025,
				title: 'Falcons Spring Shootout',
				subtitle: '2025',
			},
			{
				href: SouthPittsburghReview2025,
				title: 'South Pittsburgh Faceoff',
				subtitle: '2025',
			},
			{ href: Mar25, title: 'March Meeting Minutes', subtitle: 'March 2025' },
			{
				href: Feb25,
				title: 'February Meeting Minutes',
				subtitle: 'February 2025',
			},
		],
		2024: [
			{
				href: Dec24_2,
				title: 'December Follow-up Meeting',
				subtitle: 'December 2024',
			},
			{ href: Dec24, title: 'Meeting Minutes', subtitle: 'December 6, 2024' },
		], */
	}

	return (
		<div className='infoPage'>
			<HomeHomeNavigation />

			<div className='infoContent'>
				<div className='infoTop'>
					{/* <h1 className='infoTitle'>Info</h1>
					<p className='infoSubtitle'>
						Rules, by-laws, and official league documents
					</p> */}
				</div>

				<InfoSection label='OFFICIAL DOCUMENTS'>
					{officialDocs.map((d) => (
						<InfoRow
							key={d.title}
							href={d.href}
							title={d.title}
							subtitle={d.subtitle}
						/>
					))}
				</InfoSection>

				<InfoSection label='MEETING MINUTES'>
					{Object.keys(meetingMinutesByYear)
						.sort((a, b) => Number(b) - Number(a))
						.map((year) => (
							<div key={year} className='infoYearBlock'>
								<div className='infoYearLabel'>{year}</div>
								<div className='infoYearList'>
									{meetingMinutesByYear[year].map((m) => (
										<InfoRow
											key={`${year}-${m.title}`}
											href={m.href}
											title={m.title}
											subtitle={m.subtitle}
										/>
									))}
								</div>
							</div>
						))}
				</InfoSection>
			</div>
			<Footer />
		</div>
	)
}

export default Info
